import { createFileRoute, Link } from "@tanstack/react-router";
import { Content } from "@/components/layouts/content";
import { Header } from "@/components/layouts/header";
import { Searchbar } from "@/components/core/searchbar.tsx";
import DataTable, { type ColumnDef } from "@/components/core/data-table.tsx";
import Pagination from "@/components/core/pagination.tsx";
import { formatDate } from "@/utils/format-date.ts";
import Badge from "@/components/core/badge.tsx";
import {
	Tabs,
	TabsContent,
	TabsList,
	TabsTrigger,
} from "@/components/core/tabs.tsx";

export const Route = createFileRoute("/_dashboard/cases")({
	component: Page,
});

type Case = {
	name: string;
	status: string;
	case_type: string;
	case_priority: string;
	case_age: string;
	case_stage: string;
	location: string;
	updated_at: string; // or `Date` if you want to handle dates directly
};
const cases: Case[] = [
	{
		name: "CASE-001",
		status: "Pending",
		case_type: "Criminal",
		case_priority: "High",
		case_age: "15 days",
		case_stage: "Pre-Trial",
		location: "Mandaluyong",
		updated_at: "2025-01-10",
	},
	{
		name: "CASE-002",
		status: "Pending",
		case_type: "Civil",
		case_priority: "Medium",
		case_age: "30 days",
		case_stage: "Filing",
		location: "Makati",
		updated_at: "2025-01-08",
	},
	{
		name: "CASE-003",
		status: "Pending",
		case_type: "Family",
		case_priority: "Low",
		case_age: "45 days",
		case_stage: "Hearing",
		location: "Antipolo",
		updated_at: "2025-01-05",
	},
	{
		name: "CASE-004",
		status: "Resolved",
		case_type: "Criminal",
		case_priority: "High",
		case_age: "60 days",
		case_stage: "Closed",
		location: "Pasig",
		updated_at: "2025-01-02",
	},
	{
		name: "CASE-005",
		status: "Ongoing",
		case_type: "Labor",
		case_priority: "Medium",
		case_age: "10 days",
		case_stage: "Trial",
		location: "Quezon City",
		updated_at: "2025-01-09",
	},
	{
		name: "CASE-006",
		status: "Pending",
		case_type: "Civil",
		case_priority: "Low",
		case_age: "20 days",
		case_stage: "Hearing",
		location: "Taguig",
		updated_at: "2025-01-07",
	},
	{
		name: "CASE-007",
		status: "Resolved",
		case_type: "Tax",
		case_priority: "High",
		case_age: "90 days",
		case_stage: "Closed",
		location: "Caloocan",
		updated_at: "2025-01-03",
	},
	{
		name: "CASE-008",
		status: "Ongoing",
		case_type: "Criminal",
		case_priority: "High",
		case_age: "5 days",
		case_stage: "Investigation",
		location: "Las Piñas",
		updated_at: "2025-01-11",
	},
	{
		name: "CASE-009",
		status: "Pending",
		case_type: "Environmental",
		case_priority: "Medium",
		case_age: "25 days",
		case_stage: "Filing",
		location: "Marikina",
		updated_at: "2025-01-06",
	},
	{
		name: "CASE-010",
		status: "Pending",
		case_type: "Family",
		case_priority: "Low",
		case_age: "35 days",
		case_stage: "Hearing",
		location: "San Juan",
		updated_at: "2025-01-04",
	},
];

const columns: ColumnDef<Case>[] = [
	{
		id: "name",
		label: "Title",
		cell: ({ data }) => (
			<Link
				to="/cases/$caseId"
				params={{
					caseId: "ba2021bb-ae2b-4210-a6d7-d48a1e3e8aee",
				}}
				className="font-semibold text-blue-600 hover:text-blue-500"
			>
				{data.name}
			</Link>
		),
	},
	{
		id: "case_type",
		label: "Type",
		cell: ({ data }) => data.case_type,
	},
	{
		id: "case_priority",
		label: "Priority",
		cell: ({ data }) => data.case_priority,
	},
	{
		id: "status",
		label: "Status",
		cell: ({ data }) => (
			<Badge size="xs" color="yellow">
				{data.status}
			</Badge>
		),
	},
	{
		id: "case_stage",
		label: "Current Stage",
		cell: ({ data }) => data.case_stage,
	},
	{
		id: "location",
		label: "Location",
		cell: ({ data }) => data.location,
	},
	{
		id: "case_age",
		label: "Age",
		cell: ({ data }) => data.case_age,
	},
	{
		id: "updated_at",
		label: "Updated",
		cellClassName: "text-right",
		headerClassName: "text-right",
		cell: ({ data }) => formatDate(data.updated_at),
	},
];

function Page() {
	return (
		<Content>
			<Header />
			<div className="flex flex-col w-full max-w-[1200px] p-6">
				<div className="flex flex-col w-full gap-3">


					<Tabs defaultValue="account">
						<TabsList>
							<TabsTrigger value="account">Pending</TabsTrigger>
							<TabsTrigger value="security">Active</TabsTrigger>
							<TabsTrigger value="sessions">Tiptap</TabsTrigger>
						</TabsList>
						<TabsContent value="account">
              <div className="flex flex-col w-full gap-2">
                <Searchbar />
                <DataTable
                  data={cases}
                  columns={columns}
                  onEdit={() => {}}
                  onRowClick={() => {}}
                />
  							<Pagination
  								onClick={() => {
  									alert("Wow");
  								}}
  								initialPage={1}
  								pageCount={4}
  							/>
              </div>
						</TabsContent>
					</Tabs>
				</div>
				{/*<FullCalendar plugins={[dayGridPlugin]} initialView="dayGridMonth" />*/}
			</div>
		</Content>
	);
}
